import React, { useEffect, useState } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import "../PagesStyles/AdminMasters.css";
import { TbCircleNumber1 } from "react-icons/tb";
import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a119,
  a120,
  a121,
  a122,
  a123,
  a124,
  a18,
  a35,
  a7,
  a95,
  a96,
  a97,
  a98,
  a99,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import { currencyList } from "../../Api/AllCurrencyList";
import { Icon } from "@iconify/react";
import { useRef } from "react";
import style from "./AddNewCustomer.module.css";
import { Box } from "@mui/material";
import Customertable from "Components/support/customervendor/customer";
import toast from "react-hot-toast";

export default function AddRateNew() {
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };

  const handleList = () => {
    // Custom logic for the List button
    console.log("List button clicked");
    setActive("List");
  };

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    CurrencyName: "",
    CurrencySymbol: "",
    Multiplier: "",

    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a122, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);
  console.log(allCategories, "allCategories");
  console.log(allCompaniesList, "allCompaniesList");
  console.log(allDepartmentsList, "allDepartmentsList");
  console.log(allBranchesList, "allBranchesList");
  console.log(allRolesList, "allRolesList");

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
    if (name == "CurrencyName") {
      setNewCategory({
        ...newCategory,
        [name]: value,
        CurrencySymbol:
          currencyList.filter((x) => x.name == value)[0]?.symbol || "",
      });
    }
  };
  console.log(newCategory, "newCategory");
  console.log(newCategory, "newCategory");

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,
      CurrencyName: newCategory.CurrencyName,
      CurrencySymbol: newCategory.CurrencySymbol,
      Multiplier: newCategory.Multiplier,

      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    console.log(formData, "formData to send");
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a124 : a123,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        CurrencyName: "",
        CurrencySymbol: "",
        Multiplier: "",
        OldEntry: false,
      });
      if (data.Message) {
        // alert(data.Message);
        // setMessageType("error");
        toast.error(data.Message,{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
        setActive("AddNew");
      } else {
        // setMessageType("success");
        toast.success("Category Added Successfully",{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, "data");
    console.log(data, "data");
    console.log(data, "data");
    setNewCategory({ ...data, OldEntry: true });
    setActive("AddNew");
  };

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);
  const inputRef9 = useRef(null);
  const inputRef10 = useRef(null);
  const inputRef11 = useRef(null);
  const inputRef12 = useRef(null);
  const inputRef13 = useRef(null);
  const inputRef14 = useRef(null);
  const inputRef15 = useRef(null);
  const inputRef16 = useRef(null);
  const inputRef17 = useRef(null);
  const inputRef18 = useRef(null);
  const inputRef19 = useRef(null);
  const inputRef20 = useRef(null);
  const inputRef21 = useRef(null);
  const inputRef22 = useRef(null);

  // Focus inputRef1 on component mount
  useEffect(() => {
    inputRef1.current?.focus();
  }, []);
  // Handler function to move focus on Enter key press

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      inputRef12,
      inputRef13,
      inputRef14,
      inputRef15,
      inputRef16,
      inputRef17,
      inputRef18,
      inputRef19,
      inputRef20,
      inputRef21,
      inputRef22,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error("Submit button ref is not available");
        }
      }
    }
  };

  const columns = [
    { key: "serialNumber", label: "S.No", type: "read", priority: 2 },

    { key: "CurrencyName", label: "Currency Name", type: "read", priority: 8 },
    {
      key: "CurrencySymbol",
      label: "Currency Symbol",
      type: "read",
      priority: 9,
    },
    {
      key: "Multiplier",
      label: "Multiplier",
      type: "read",
      priority: 10,
    },
  ];


  const handlenew = () => {
    setActive("AddNew");
  };

  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: "130px" }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}

        <AdminBreadCrump
          title={"Add Rate Conversion"}
          companyName={"Loyalstring"}
          module={"User Masters"}
          page={"Rate Conversion"}
        />
      </div>

      <div style={{ padding: "16px" }}>
        {
          (active == "List" ? (
            <>
               <div className={style["white-space"]}>
               

               <div className={style["icon-div"]}>
                 <div className={style["search-container"]}>
                   <input
                     type="text"
                     value={searchInput}
                     onChange={handleSearchChange}
                     placeholder="Search..."
                     className={style["serach-input"]}
                   />
                   <button
                     style={{ margin: 0 }}
                     className={style["search-btn"]}
                     onClick={handleSearchSubmit}
                   >
                     <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                   </button>
                 </div>
                 
                 <Icon
                 
                   style={{
                     fontSize: "28px ",
                     color: "#0077d4",
                     cursor: "pointer",
                   }}
                   icon="bx:export"
                 />
                 
                
                 <button
                   // style={{ width: "30%" }}
                   className={style["custom-btn"]}
                 >
                   <Icon
                     style={{ fontSize: "24px " }}
                     icon="ic:outline-print"
                   />
                   Print
                 </button>
                 <button onClick={handlenew} style={{ margin: 0 }} className={style["custom-btn"]}>
                 New
                 <Icon icon="mdi:plus" width="24" height="24" />
               </button>
               </div>
             </div>

              <Customertable
                columns={columns}
                allCategories={allCategories}
                handleEditData={handleEditData}
                searchInput={searchInput}
                setSearchInput={setSearchInput}

                // title={"All Customers"}
              />
            </>
          ) : (
            <div className={style.adminAddCategoryMainBox}>
              <div className={style.adminAddCategoryInnerBox}>
                <div className={style.adminCategoryAddCategoryMainBox}>
                  <p>Add New Rate Conversion</p>
                  <form style={{ width: "100%" }} onSubmit={addNewCategory}>
                    <div
                      style={{
                        gridTemplateColumns: "repeat(4,2fr)",
                        columnGap: "30px",
                        margin: "0px 0px",
                        padding: "var(--Space-0, 0px) 24px",
                      }}
                      // className="adminCategoryAddCategoryInnerBox"
                    >
                      {/* <Box sx={{ width: "95%", margin: "0 auto" }}>
                        <div
                          style={{
                            gridTemplateColumns: "repeat(4,1fr)",
                            columnGap: "40px",
                            margin: "15px 0px",
                          }}
                          className="adminCategoryAddCategoryInnerBox"
                        >
                        <label>
                          Currency Name <sup>*</sup>
                        </label>
                        <select
                          required
                          name="CurrencyName"
                          value={newCategory.CurrencyName}
                          onChange={handleNewCategoryChange}
                        >
                          <option value="">Select Currency Name</option>
                          {currencyList.map((currency, index) => (
                            <option key={index} value={currency.name}>
                              {currency.name}
                            </option>
                          ))}
                        </select>
                        <label>
                          Currency Symbol <sup>*</sup>
                        </label>
                        <input
                          style={{ cursor: "not-allowed" }}
                          name="CurrencySymbol"
                          value={newCategory.CurrencySymbol}
                          readOnly
                          type="text"
                        
                        />
                       
                        <label>
                          Multiplier (compared to $) <sup>*</sup>
                        </label>
                        <input
                          required
                          name="Multiplier"
                          value={newCategory.Multiplier}
                          onChange={handleNewCategoryChange}
                          type="text"
                          placeholder="Between 0 to 100"
                        />
                        </div>
                      </Box> */}
                      <Box sx={{ width: "95%", margin: "0 auto" }}>
                        <div
                          style={{
                            gridTemplateColumns: "repeat(4,1fr)",
                            columnGap: "40px",
                            margin: "15px 0px",
                          }}
                          className="adminCategoryAddCategoryInnerBox"
                        >
                          <label>
                            Currency Name <sup>*</sup>
                          </label>
                          <select
                            required
                            name="CurrencyName"
                            value={newCategory.CurrencyName}
                            onChange={handleNewCategoryChange}
                            ref={inputRef1}
                            onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                          >
                            <option value="">Select Currency Name</option>
                            {currencyList.map((currency, index) => (
                              <option key={index} value={currency.name}>
                                {currency.name}
                              </option>
                            ))}
                          </select>

                          <label>
                            Currency Symbol <sup>*</sup>
                          </label>
                          <input
                            style={{ cursor: "not-allowed" , border: '1px solid #ddd'}}
                            name="CurrencySymbol"
                            value={newCategory.CurrencySymbol}
                            readOnly
                            type="text"
                            ref={inputRef2}
                            onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                            
                          />

                          <label>
                            Multiplier (compared to $) <sup>*</sup>
                          </label>
                          <input
                           style={{ cursor: "not-allowed" , border: '1px solid #ddd'}}
                            required
                            name="Multiplier"
                            value={newCategory.Multiplier}
                            onChange={handleNewCategoryChange}
                            type="number"
                            placeholder="Between 0 to 100"
                            ref={inputRef3}
                          />
                        </div>
                      </Box>
                    </div>
                    {!loading ? (
                      <div className={style["btn-container"]}>
                        <button className={style.buttons} type="submit">
                          <Icon
                            icon="ic:baseline-check"
                            width="24"
                            height="24"
                          />{" "}
                          Submit
                        </button>
                        <button
                          className={style.buttons}
                          style={{
                            backgroundColor: "#fff",
                            color: "#0077d4",
                            border: "1px solid #0077d4",
                          }}
                          type="button"
                          onClick={handleResetField}
                        >
                          <Icon
                            style={{ color: "#0077d4" }}
                            icon="ix:reset"
                            width="24"
                            height="24"
                          />
                          Reset
                        </button>
                        <button
                          className={style.buttons}
                          type="button"
                          onClick={handleList}
                        >
                          <Icon
                            icon="fluent:list-rtl-16-filled"
                            width="24"
                            height="24"
                          />
                          List
                        </button>
                      </div>
                    ) : null}
                  </form>
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}
